import { Component } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'slider-accessibility',
  templateUrl: './slider-accessibility.component.html',
  styleUrls: ['./slider-accessibility.component.sass']
})
export class SliderAccessibilityComponent {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }
}
